module.exports = __webpack_public_path__ + "img/Ask-for-Demo.ac4f84b2.svg";